import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";
import { QuickLoanService } from "../services/quickLoan.service";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MatSelectChange } from "@angular/material/select";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SnackbarComponent } from "src/app/snackbar/snackbar.component";

@Component({
    selector: "app-quickloan-loan-key-factor",
    templateUrl: "./quickloan-loan-key-factor.component.html",
    styleUrls: ["./quickloan-loan-key-factor.component.scss"],
    standalone: false
})
export class QuickloanLoanKeyFactorComponent implements OnInit {
  @Input() loanSummary: any;
  @Input() Processid: any;
  @Input() PageData: any;
  @Input() Status: any;
  @Input() ProcessName: any;
  @Input() Revert_IsEdit: any;
  @Output() action: EventEmitter<any> = new EventEmitter<any>();
  // selectedValues: any[] = [];
  showSpinner: boolean = false;
  dataSource: any;
  Remarks: any;
  currentUser: any;
  isShowingText: boolean = true;
  isEditing: boolean = false; // Default state
  showEditButton: boolean = false; // Control initial button state

  displayedColumns: string[] = ["Id", "scoreType", "values", "Score"];

  filteredDropdownData: {
    [key: string]: { ScoringDetailId: number; Id: number }[];
  } = {};
  dataSourceValues: any;
  isSaveDisabled: boolean = true;
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  constructor(
    private _QuickLoanService: QuickLoanService,
    private dataSharingService: DataSharingService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // console.log("processsss", this.Processid);
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next(this.ProcessName);

  

    this.getLoanKeyFactorDetails();
  }

  getLoanKeyFactorDetails() {
    this.showSpinner = true;

    this._QuickLoanService
      .QuickLoan_Scoring_Detail_Data({
        LoanId: this.loanSummary.LoanId,
      })
      .subscribe((response: any) => {
        this.dataSourceValues = [
          ...response.Item1,
          ...this.transformData(response.Item2),
        ];

        this.dataSource = new MatTableDataSource(this.dataSourceValues);
        // console.log("DataSourceAftermerge", this.dataSource.filteredData);
        this.dataSource.filteredData
          .filter((element: any) => element.IsDyanamic == false)
          .forEach((element: any) => {
         
            if (element.ScoreValuedata != null) {
              element.ScoreValue = element.values.find(
                (x) => x.ScoringDetailId == element.ScoreValuedata
              );
              element.scoreViewName = element.values.find(
                (x) => x.ScoringDetailId == element.ScoreValuedata
              ).value;
            }
           
          });

        if (this.Processid == 2 || this.Processid == 22 || this.Processid == 20) {
          this.displayedColumns = ["Id", "scoreType", "values", "Score"];
        } else {
          this.displayedColumns = ["Id", "scoreType", "values"];
        }
        this.isEditing = this.dataSource.filteredData.some(
          (element: any) => element.ScoreValue == null
        );

        // this.showEditButton = !this.isEditing;

        if (response.Item2 && response.Item2.length > 0) {
          this.Remarks = response.Item2[0].Remark || ""; // Assign Remarks value
        }

        //this.showEditButton = this.dataSource.filteredData.some(
        //  (element: any) => element.ScoreValue && element.ScoreValue > 0
        //);
        this.checkInitialData();
      });
  }

  transformData(data: any[]): any[] {
    // console.log("Data for item2222", data);
    const groupedData = new Map();

    data.forEach((item) => {
      if (!groupedData.has(item.Id)) {
        groupedData.set(item.Id, {
          Id: item.Id,
          ScoreType: item.ScoreType,
          Score: item.Score,
          values: [],
          IsDyanamic: item.IsDyanamic,
          ScoreValuedata: item.ScoreValue,
          Remarks: item.Remark,
          FinalScore: item.FinalScore,
        });
      }

      groupedData.get(item.Id).values.push({
        Id: item.Id,
        value: item.value,
        ScoringDetailId: item.ScoringDetailId,
        Score: item.Score,
      });
    });

    return Array.from(groupedData.values());
  }

  checkInitialData() {
    const hasExistingScore = this.dataSource.filteredData.some(
      (item) =>
        !item.IsDyanamic &&
        item.ScoreValue !== null &&
        item.ScoreValue !== undefined &&
        item.ScoreValue !== ""
    );

    if (hasExistingScore) {
      this.isEditing = false;
      //  this.showEditButton = true;
    } else {
      this.isEditing = true;
      // this.showEditButton = false;
    }
  }

  canSave(): boolean {
    if (!this.isEditing) return true;

    const allDropdownsSelected = (this.dataSource?.filteredData || []).every(
      (item) =>
        (!item.IsDyanamic || item.IsDyanamic == 'false' || item.IsDyanamic == 0)
          ? (item.ScoreValue !== undefined && item.ScoreValue !== null && item.ScoreValue !== "")
          : true
    );

    const isRemarksFilled = !this.Remarks || typeof this.Remarks !== "string" || this.Remarks.trim() !== "";

    return allDropdownsSelected && isRemarksFilled;
  }

  onDropdownChange(element: any) {
    // console.log("element", element);
    this.canSave();
    this.cdr.detectChanges();
  }
  onRemarksChange() {
    // console.log("Remarks Updated:", this.Remarks);
    this.canSave();
  }

  onSave() {
    this.showSpinner = true;

    let selectedValues = [];

    this.dataSource.filteredData
      .filter((element: any) => (!element.IsDyanamic || element.IsDyanamic == 'false' || element.IsDyanamic == 0) && element.ScoreValue)
      .forEach((element: any) => {
        selectedValues.push({
          Id: element.Id,
          ScoringDetailId: element.ScoreValue.ScoringDetailId ? element.ScoreValue.ScoringDetailId : element.ScoreValue,
          Score: element.ScoreValue.Score ? element.ScoreValue.Score : 0,
        });
      });

    const payload = {
      LoanId: this.loanSummary.LoanId,
      Remark: this.Remarks,
      LoginUserId: this.currentUser.userId,
      Json: JSON.stringify({
        ScoringDetail: selectedValues,
      }),
    };

    this._QuickLoanService
      .QuickLoan_Save_Scoring_Detail_Data(payload)
      .subscribe((res: any) => {
        if (res[0].CODE == 1) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.getLoanKeyFactorDetails();
          this.QuickLoan_Save_PageProcess();
          this.toggleEditing();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
  }

  totaltypewise(type) {
    if (this.dataSource != null) {
      let sum = 0;
      for (let i = 0; i < this.dataSource.filteredData.length; i++) {
        sum += Number(this.dataSource.filteredData[i][type]);
      }
      return sum > 0 ? sum.toFixed(2) : 0;
    }
    return 0;
  }

  nextPageRedirectFunc() {
    this.action.emit("next");
  }

  QuickLoan_Save_PageProcess() {
    this._QuickLoanService
      .QuickLoan_Save_PageProcess({
        PageType: "Loan Key Factor",
        ProductId: this.loanSummary.ProductId,
        Loan_Id: this.loanSummary.LoanId,
        Process_Id: this.Processid,
        Page_Id: this.PageData.MM_Id,
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res) => {
        //return res[0].CODE;
      });
  }

  toggleEditing() {
    this.isShowingText = !this.isShowingText; // Toggle edit mode
  }

  saveChanges() {
    this.onSave();
    this.isEditing = false;
    return this.dataSource.filteredData.every((element) => {
      return (
        element.Score !== 0 &&
        element.Score !== null &&
        element.ScoreValue !== null
      );
    });
  }
  toggleEditMode() {
    if (this.isEditing) {
      this.saveChanges(); // Save data when clicking Save
    } else {
      this.isEditing = true;
    }
  }
  //enableEditing() {
  //  this.isEditing = true;
  //}
}
